<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    />
    <!-- 审批弹框 -->
    <approval-dialog
      :dialogVisible="dialogObj.show"
      :approvalData="dialogObj.data"
      :callbackFn="dialogObj.cb"
      :title="dialogObj.title"
      @close="dialogObj.show = false"
      @refreash="m_getApprovalTaskList"
    />
  </div>
</template>
<script>
import ApprovalDialog from '../../components/approvalDialog'
// eslint-disable-next-line import/no-cycle
import mixin from '../../mixins/approvalTask'
import approvalCommon from '../../mixins/approvalCommon'

export default {
  components: {
    ApprovalDialog,
  },
  mixins: [mixin, approvalCommon],
  data() {
    return {
      dialogObj: {
        show: false,
        data: null,
        title: '确认驳回原因',
      },
    }
  },
  methods: {
    // 审批
    // eslint-disable-next-line vue/no-unused-properties
    approvalHandle({ id, bizType }, state) {
      // this.dialogObj.cb = this.searchHandle
      this.dialogObj.data = {
        id,
        bizType,
        state,
      }
      this.dialogObj.title = state === 30 ? '确认驳回原因' : '确认通过'
      this.dialogObj.show = true
    },
  },
}
</script>
<style scoped lang="scss">
.collect-box {
  display: flex;
  justify-content: end;
  padding-top: 16px;
}
</style>
